import { Metric } from '@strength/domain';
import { DateTime } from 'luxon';
import { WorkoutWithCycleAndSession } from '../../types';
import { WorkoutSummaryPrescriptionMutationFns } from '../types';
import { getSlotsForMonth } from './common';
import { PrescriptionSlot } from './PrescriptionSlot';

export const getPrescriptionSlotsForMetricValue = (
  metricKeyword: string,
  workouts: WorkoutWithCycleAndSession[],
  mutationFns: WorkoutSummaryPrescriptionMutationFns,
  month: number,
  year: number,
  x: number,
  y: number,
  getMetric: (metricId: string) => Metric,
  readOnly?: boolean,
) => {
  const getWorkoutForDay = (date: string) => {
    return workouts.find((w) => w.assignedDate === date);
  };

  return getSlotsForMonth(
    x,
    y,
    month,
    year,
    (x, y, day) => {
      const curDay = DateTime.fromObject({ month, day, year }).toFormat(
        'yyyy-MM-dd',
      );
      const workout = getWorkoutForDay(curDay);
      return PrescriptionSlot({
        x,
        y,
        workout,
        metricKeyword,
        mutationFns,
        getMetric,
        readOnly,
      });
    },
    true,
  );
};
